import { createSlice } from '@reduxjs/toolkit'

import { InstagramState } from 'apps/instagram/models/interfaces'
import { loadPersonalizedDataReducer } from 'apps/instagram/store/actions/loadPersonalizedData'
import { toggleInstagramChannelReducer } from 'apps/instagram/store/actions/toggleChannel'

export const initialState: InstagramState = {
  toggleChannelFetching: false,
  personalizedData: {
    isFetching: false,
    isFetched: false,
    niche: null,
  },
}

const { reducer } = createSlice({
  name: 'instagram',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    toggleInstagramChannelReducer(builder)
    loadPersonalizedDataReducer(builder)
  },
})

export const instagramReducer = reducer
